import React, { useState, FC, useRef, useEffect, Fragment } from 'react';
import { ReactComponent as CsvIcon } from 'assets/icons/csv-icon.svg';
import { ActiveType } from '.';
import XlsInfoModal from 'components/xls-info-modal';
import TextsContent from './contents.json';

export type FileDetailsType = {
  name?: string;
  phone_number?: string;
  role?: string;
  dob?: string;
  budget: string;
  budget_duration?: string;
  budget_setting?: string;
  department?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
};

type CsvFileProps = {
  setFile: (item: File | null) => void;
  setFileDetails: (item: FileDetailsType[]) => void;
  fileDetails: FileDetailsType[] | null;
  active: ActiveType | null;
  setActive: (item: ActiveType) => void;
  isFormEmpty?: boolean;
  formType: 'guests' | 'members';
};

const AddCsvFile: FC<CsvFileProps> = ({
  setFile,
  setFileDetails,
  fileDetails,
  active,
  setActive,
  isFormEmpty,
  formType
}) => {
  const [hasUploaded, setHasUploaded] = useState(false);
  const [allowDrop, setAllowDrop] = useState(true);

  const handleFileDrop = (e: any) => {
    if (allowDrop) {
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files) setFile(files[0]);
    }
  };

  const { title, subtitle, steps, description, downloadLink } = TextsContent[formType] || {};

  const [showXlsInfoModal, setShowXlsInfoModal] = useState(false);
  const handleDragOver = (e: any) => {
    if (allowDrop) e.preventDefault();
  };
  const fileUploadRef = useRef<HTMLInputElement | null>(null);

  const reset = () => {
    setActive('xls');
    setFileDetails([]);
  };
  const handleFileUpload = (e: any) => {
    setHasUploaded(false);
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  useEffect(() => {
    setAllowDrop(true);
    if (fileDetails && fileDetails?.length > 0) {
      setShowXlsInfoModal(false);
    }
  }, [fileDetails]);

  const borderClass =
    !active || isFormEmpty
      ? 'border-[#EAEBEB] hover:border-[#E60A2B] cursor-pointer'
      : 'border-[#EAEBEB] hover:border-[#EAEBEB] cursor-not-allowed';

  return (
    <Fragment>
      <div
        onClick={() => {
          setShowXlsInfoModal(true);
        }}
        onDrop={handleFileDrop}
        onDragOver={handleDragOver}
        className={`border w-full sm:w-[185px] h-[139px] ${borderClass} hover:border-[1.5px] p-2 sm:p-4 rounded-md space-y-3 flex flex-col`}>
        <div className='border border-[#EAEBEB] p-2 rounded-full w-9 h-9 flex items-center'>
          <CsvIcon />
        </div>
        <h2 className='text-sm font-semibold'>Add via .xls</h2>
        <p className='text-[#6F7376] text-xs font-normal '>{description} </p>
      </div>
      <input
        ref={fileUploadRef}
        type='file'
        accept='.xlsx, .xls'
        hidden
        onChange={handleFileUpload}
        disabled={!hasUploaded && fileDetails?.length !== 0}
      />
      <XlsInfoModal
        title={title}
        show={showXlsInfoModal}
        onClose={() => setShowXlsInfoModal(false)}
        handleFileUpload={handleFileUpload}
        handleFileChange={reset}
        downloadLink={downloadLink}>
        <div className='w-full max-w-[400px]'>
          <h2 className='text-sm text-[#2E3031]'>{subtitle}</h2>
          <div>
            {steps.map((step) => (
              <div className='flex items-center max-w-[400px]' key={step.number}>
                <div className='number-container'>
                  <span className='number mb-2 mr-2'>{step.number}</span>
                </div>
                <span className='mt-3'>
                  <h3 className='text-sm font-medium '>{step.heading}</h3>
                  <p className='text-xs'>{step.description}</p>
                </span>
              </div>
            ))}
          </div>
        </div>
      </XlsInfoModal>
    </Fragment>
  );
};

export default AddCsvFile;
